const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

const getIframeToken = () => {
  if (!isInIframe()) return null;
  try {
    return localStorage.getItem("x-token");
  } catch {
    return null;
  }
};

const setIframeToken = (token) => {
  if (!isInIframe() || !token) return;
  try {
    localStorage.setItem("x-token", token);
  } catch {
    // ignore storage errors
  }
};

const clearIframeToken = () => {
  if (!isInIframe()) return;
  try {
    localStorage.removeItem("x-token");
  } catch {
    // ignore storage errors
  }
};

export { isInIframe, getIframeToken, setIframeToken, clearIframeToken };
